import React from 'react';


function Analytics() {
    return (
        <div style={{ width: '90%', margin: 'auto', marginTop: '50px', }}>
            <h5 style={{ fontWeight: '800', fontSize: '15px' }}>Analytics</h5>

            <div>

            </div>
        </div>
    )
}

export default Analytics